import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private selectedDateSource = new BehaviorSubject<{ startDate?: string; endDate?: string } | null>(null);
  selectedDate$ = this.selectedDateSource.asObservable();

  private initialSelectedHotelId = localStorage.getItem('selectedHotelId');
  private selectedHotelIdSource = new BehaviorSubject<string | null>(this.initialSelectedHotelId ? this.initialSelectedHotelId : null);
  selectedHotelId$ = this.selectedHotelIdSource.asObservable();

  private selectedHotelDataSource = new BehaviorSubject<any>(null);
  selectedHotelData$ = this.selectedHotelDataSource.asObservable();

  private hotelList = new BehaviorSubject<any>(null);
  accountHotelList$ = this.hotelList.asObservable();

  constructor(private httpService: HttpService, private datePipe: DatePipe) { }

  // API call to upload image
  uploadImage(endpoint: string, payload: FormData): Observable<any> {
    return this.httpService.postData(`${endpoint}`, payload);
  }

  setSelectedDate(dates: { startDate?: string; endDate?: string } | null): void {
    this.selectedDateSource.next(dates);
  }

  setSelectedHotel(hotelId: string | null): void {
    if (hotelId) {
      localStorage.setItem('selectedHotelId', hotelId);
      const storedHotelId = localStorage.getItem('selectedHotelId');
      if (storedHotelId === String(hotelId)) {
        this.selectedHotelIdSource.next(hotelId);
      } else {
        console.error('Failed to set selectedHotelId in localStorage.');
      }
    } else {
      localStorage.removeItem('selectedHotelId');
      this.selectedHotelIdSource.next(null);
    }
  }

  getSelectedHotel(): string | null {
    const storedHotelId = localStorage.getItem('selectedHotelId');
    if (storedHotelId) {
      this.selectedHotelIdSource.next(storedHotelId);
      return storedHotelId;
    } else {
      console.error('No hotel ID found in localStorage.');
      return null;
    }
  }

    setAccountHotels(hotels): void {
    this.hotelList.next(hotels)
  }

  getAccountHotels(): string | null {
    return this.hotelList.value
  }



  clearSelectedHotel(): void {
    this.selectedHotelIdSource.next(null);
    localStorage.removeItem('selectedHotelId');
  }
}
